import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'CLASSROOM_STUDENTS_GET_ALL',
  GET_ALL_SUCCESS: 'CLASSROOM_STUDENTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CLASSROOM_STUDENTS_GET_ALL_FAILURE',
  INVALIDATE_LIST: 'CLASSROOM_STUDENTS_INVALIDATE_LIST',
};

export const getAll = actions.getAll(
  ({ teacherClassroomId }) =>
    `${BASE_URL}/teacher-classrooms/${teacherClassroomId}/students/`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
